import { t } from '../i18n';
import { useToasts } from './toast';

export function Toasts() {
  const items = useToasts((s) => s.items);
  const dismiss = useToasts((s) => s.dismiss);
  return (
    <div className="toasts" role="status" aria-live="polite">
      {items.map((x) => (
        <div key={x.id} className={`toast ${x.kind}`}>
          <span className={`dot ${x.kind === 'ok' ? 'green' : x.kind === 'err' ? 'red' : x.kind === 'warn' ? 'amber' : 'accent'}`} style={{ marginTop: 5 }} />
          <span>{x.text}</span>
          {x.action && (
            <button
              type="button"
              className="btn xs primary"
              style={{ flexShrink: 0 }}
              onClick={() => {
                x.action!.onClick();
                dismiss(x.id);
              }}
            >
              {x.action.label}
            </button>
          )}
          <button type="button" className="x" aria-label={t('common.dismiss')} onClick={() => dismiss(x.id)}>
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
